import clsx from 'clsx';

export interface TextProps {
  className?: string;
  children?: React.ReactNode;
  dimmed?: boolean;
}
export function Text({ className, children, dimmed }: TextProps) {
  return (
    <div
      className={clsx(className, {
        'text-muted-foreground': dimmed,
      })}>
      {children}
    </div>
  );
}
